import { atom } from 'jotai';
import { AuthUser, AuthState } from '@/lib/auth/types';
import { getSession } from '@/lib/auth/session';

// Auth user atom — the React-facing mirror of the persisted session. session.ts
// is the single writer to localStorage; this atom is seeded from it on load (so
// a refresh restores the user without a flash) and kept in sync by AuthProvider.
export const authUserAtom = atom<AuthUser | null>(getSession()?.user ?? null);

// Auth loading state
export const authLoadingAtom = atom<boolean>(false);

// Auth error state
export const authErrorAtom = atom<string | null>(null);

// Derived auth state atom - follows Single Responsibility
export const authStateAtom = atom<AuthState>((get) => ({
  user: get(authUserAtom),
  isAuthenticated: get(authUserAtom) !== null,
  isLoading: get(authLoadingAtom),
  error: get(authErrorAtom),
}));

// Auth actions - separate concerns
export const setAuthUserAtom = atom(
  null,
  (_get, set, user: AuthUser | null) => {
    set(authUserAtom, user);
    set(authErrorAtom, null);
  }
);

export const setAuthLoadingAtom = atom(
  null,
  (_get, set, loading: boolean) => {
    set(authLoadingAtom, loading);
  }
);

export const setAuthErrorAtom = atom(
  null,
  (_get, set, error: string | null) => {
    set(authErrorAtom, error);
  }
);

export const clearAuthAtom = atom(
  null,
  (_get, set) => {
    set(authUserAtom, null);
    set(authLoadingAtom, false);
    set(authErrorAtom, null);
  }
);
